import { Button } from "../../../components/ui/button";
import { useReadOnly } from "../../lock/ReadOnlyContext";

type FooterActionProperties = {
  onSave?: () => void;
  onExit?: () => void;
  /**
   * When another analyst holds the deal lock, hide Save entirely — there is
   * nothing this user can save, so a disabled button would only add noise.
   */
  hideSave?: boolean;
};

function FooterAction({ onSave, onExit, hideSave = false }: FooterActionProperties) {
  const readOnly = useReadOnly();

  return (
    <footer className="border-border bg-card flex shrink-0 items-center justify-end gap-2 border-t px-4 py-2 lg:px-6 lg:py-2.5">
      <Button variant="outline" size="sm" onClick={onExit}>
        Exit
      </Button>
      {!hideSave && (
        <Button size="sm" onClick={onSave} disabled={readOnly}>
          Save
        </Button>
      )}
    </footer>
  );
}

export default FooterAction;
